export default __webpack_public_path__ + "static/media/circle.292ce4e1.svg";